import React from 'react';
import * as ReactDOM from 'react-dom';
import PreviewDialog from './PreviewDialog';
import { disableBodyScroll, enableBodyScroll, } from 'body-scroll-lock';
function openPreview(config) {
    if (!document) {
        return;
    }
    const div = document.createElement('div');
    document.body.appendChild(div);
    disableBodyScroll(div);
    let currentConfig = Object.assign(Object.assign({}, config), { close });
    function close(...args) {
        currentConfig = Object.assign({}, currentConfig);
        render(currentConfig);
        config.onClose && config.onClose(...args);
        enableBodyScroll(div);
        setTimeout(() => {
            destroy(...args);
        }, 300);
    }
    function update(newConfig) {
        currentConfig = Object.assign(Object.assign({}, currentConfig), newConfig);
        render(currentConfig);
    }
    function destroy(...args) {
        const unmountResult = ReactDOM.unmountComponentAtNode(div);
        if (unmountResult && div.parentNode) {
            div.parentNode.removeChild(div);
        }
        const triggerCancel = args && args.length && args.some(param => param && param.triggerCancel);
        if (config.onClose && triggerCancel) {
            config.onClose(...args);
        }
    }
    function render(props) {
        ReactDOM.render(<PreviewDialog {...props}/>, div);
    }
    render(currentConfig);
    return {
        destroy: close,
        update,
    };
}
export default openPreview;



// WEBPACK FOOTER //
// ./components/photo-preview/OpenDialog.tsx